<template>
  <div class="cell-panel">
    <div v-if="isEditMode" class="editor fh">
      <div class="field">
        <div class="input">
          <el-input class="fw" v-model="cellData.name" :maxlength="6" placeholder="格口名称" />
        </div>
      </div>
      <div class="field">
        <div class="input">
          <el-input-number class="fw" v-model="cellData.num" :min="0" :max="99" step-strictly placeholder="格口号" />
        </div>
      </div>
      <div class="field">
        <el-button class="fw" size="mini" type="primary" @click="handleConfirm">确定</el-button>
      </div>
    </div>
    <div v-else class="view fh" @click="handleEdit">
      <div class="field">
        <div class="input">
          <div class="text">{{ cellData.name || '--' }}</div>
        </div>
      </div>
      <div class="field">
        <div class="input">
          <div class="text">{{ _.isNumber(cellData.num) || cellData.num ? cellData.num : '--' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, _ } from '@zto/zpage'

const props = defineProps<{
  cellData: any
  disabled: boolean
}>()

const isEditMode = ref<boolean>(false)

function handleEdit() {
  if (props.disabled) return
  isEditMode.value = true
}

function handleConfirm() {
  isEditMode.value = false
}
</script>

<style lang="scss" scoped>
.cell-panel {
  height: 100%;
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  padding: 5px;
  box-sizing: border-box;

  .editor {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .field {
      display: flex;

      .input {
        width: 100%;
      }
    }
  }

  .view {
    cursor: pointer;
    .field {
      text-align: center;
    }
  }
}
</style>
